<template>
    <div class="fixed z-50 bottom-0 right-0 mr-4 md:mr-8">
        <div v-if="$page.props.flash.success && show"
             class="mb-4 md:mb-8 flex items-center justify-between bg-green-400 rounded max-w-3xl text-white cursor-pointer">
            <div class="flex items-center">
                <inertia-link
                    v-if="$page.props.flash.link"
                    :href="$page.props.flash.link"
                >
                    <div class="px-4 py-4 text-white text-sm font-medium">
                        {{ $t($page.props.flash.success) }}
                        <font-awesome-icon icon="arrow-right" />
                    </div>
                </inertia-link>
                <div v-else>
                    <div class="px-4 py-4 text-white text-sm font-medium">
                        {{ $page.props.flash.success }}
                    </div>
                </div>
            </div>
            <a class="mr-3 p-2" @click="close">
                <font-awesome-icon icon="times"/>
            </a>
        </div>
        <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show"
             class="mb-4 md:mb-8 flex items-center justify-between bg-red-500 rounded max-w-3xl text-white cursor-pointer">
            <div class="flex items-center">
                <div v-if="$page.props.flash.error" class="px-4 py-4 text-white text-sm font-medium">{{ $t($page.props.flash.error) }}</div>
                <div v-else class="px-4 py-4 text-white text-sm font-medium">
                    <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
                    <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
                </div>
            </div>
            <a class="mr-3 p-2" @click="close">
                <font-awesome-icon icon="times"/>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        show: true,
        timeout: null,
    }),
    watch: {
        '$page.flash': {
            handler() {
                this.openForTimeout();
            },
            deep: true,
        },
        '$page.errors': {
            handler() {
                this.openForTimeout();
            },
            deep: true,
        },
    },
    methods: {
        openForTimeout() {
            clearTimeout(this.timeout);
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
                this.timeout = setTimeout(() => {
                    this.close();
                }, 5000);
            });
        },
        close() {
            this.$page.props.flash = [];
        }
    }
}
</script>
